import React from "react";
import cn from "classnames";

import { HeadingProps } from "../Heading.props";
import styles from "./H2.module.scss";

/**
 * @deprecated
 */
const H2: React.FC<HeadingProps> = ({ children, id, testId, className, roboto, large, semiBold }: HeadingProps): JSX.Element => {
  const headerClasses = cn(
    styles["h2"],
    { [styles["roboto"]]: roboto },
    { [styles["large"]]: large },
    { "semi-bold": semiBold },
    className,
  );

  return (
    <h2 className={headerClasses} id={id} data-testid={testId ? `test__${testId}` : undefined}>
      {children}
    </h2>
  );
};

/**
 * @deprecated
 */
export default H2;
